import { HYPERLINK_CONTEXT_INTENT_ID_ATTR, WEB_SEARCH_RESULT_ATTACHMENT_NAME } from '@sa/bff-contract';
import { hooks } from 'botframework-webchat';
import React, { useLayoutEffect, useRef } from 'react';
const { useSendEvent } = hooks;
const createOpenUrlEventActivity = (value) => ({
    name: 'openURL',
    value
});
const createOpenWebSearchResultUrlEventActivity = (value) => ({
    name: 'openWebSearchResultURL',
    value
});
export const openUrlEventHandlerMiddleware = () => (next) => (...args) => {
    const [{ activity }] = args;
    const render = next(...args);
    if (activity.type === 'message' && render) {
        return (...children) => {
            const wrapperEl = useRef(null);
            const sendEvent = useSendEvent();
            useLayoutEffect(() => {
                var _a, _b;
                const isWebSearchAttachment = !!((_a = activity.attachments) === null || _a === void 0 ? void 0 : _a.find((attachment) => attachment.name === WEB_SEARCH_RESULT_ATTACHMENT_NAME));
                (_b = wrapperEl.current) === null || _b === void 0 ? void 0 : _b.querySelectorAll('[aria-roledescription=message]').forEach((e, i) => {
                    e.querySelectorAll('a').forEach((anchor) => {
                        anchor.onclick = () => {
                            var _a;
                            const payload = {
                                url: anchor.href,
                                sourceActivityId: activity.id,
                                answerIndex: i,
                                linkText: anchor.text
                            };
                            if (isWebSearchAttachment) {
                                const { name, value } = createOpenWebSearchResultUrlEventActivity(payload);
                                sendEvent(name, value);
                            }
                            else {
                                const sourceIntentId = (_a = anchor.getAttribute(HYPERLINK_CONTEXT_INTENT_ID_ATTR)) !== null && _a !== void 0 ? _a : '';
                                const { name, value } = createOpenUrlEventActivity(Object.assign(Object.assign({}, payload), { sourceIntentId }));
                                sendEvent(name, value);
                            }
                        };
                    });
                });
            });
            return React.createElement("div", { ref: wrapperEl }, render(...children));
        };
    }
};
//# sourceMappingURL=openUrlEventHandlerMiddleware.js.map